<template>
  <div>
    <!-- 加入overfloa-x参数使得在窗口变化的时候, 图不会突出去, 然后在刷新时候,echarts的自适应会消掉这个滑轨 -->
    <div id="umap" :style="{ width: '100%', height: '400px' }"></div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      efficiency: "",
    };
  },
  created() {
    axios
      .get(
        "http://research.gzsys.org.cn/perturbdb/API/publications_efficiency.php",
        {
          params: { datasetId: this.$route.query.datasetId },
        }
      )
      .then((response) => {
        this.efficiency = response.data;
        this.drawLine(this.efficiency["gene"], this.efficiency["percent"]);
      });
  },
  mounted() {},
  methods: {
    drawLine(gene, percent) {
      // 基于刚刚准备好的 DOM 容器，初始化 EChart 实例
      let myChart = this.$echarts.init(document.getElementById("umap"));
      // 绘制图表
      myChart.setOption({
        // title: { text: "vue中使用echarts进行绘制图" },
        tooltip: {},
        toolbox: {
          feature: {
            dataZoom: {
              yAxisIndex: false,
            },
            dataView: {},
            saveAsImage: {
              pixelRatio: 2,
            },
          },
        },
        height: 250,
        // width:"100%",
        // height:"290px",
        xAxis: {
          axisLabel: {
            rotate: -45,
            color: "black",
          },
          data: gene,
        },
        yAxis: {},
        series: [
          {
            name: "Perturbation rate (%)",
            type: "bar",
            data: percent,
            color: "#4572a7",
          },
        ],
      });
      //随着窗口的拖动,图自适应窗口的大小
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },
  },
};
</script>
